import { connect } from 'react-redux';

import { appModalClose } from 'actions';

import View from './';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    appModalClose() {
      dispatch(appModalClose());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(View);



// WEBPACK FOOTER //
// ./js/components/modal/navigator/container.js